import { render, staticRenderFns } from "./CustomerMatchNetConfirm.vue?vue&type=template&id=5fba22c4"
import script from "./CustomerMatchNetConfirm.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchNetConfirm.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchNetConfirm.vue?vue&type=style&index=0&id=5fba22c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports